var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#DFE0E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 13.3334V26.6667H24.1667V13.3334H15.8333ZM15 11.6667H25C25.221 11.6667 25.433 11.7545 25.5892 11.9108C25.7455 12.0671 25.8333 12.2791 25.8333 12.5001V27.5001C25.8333 27.7211 25.7455 27.9331 25.5892 28.0893C25.433 28.2456 25.221 28.3334 25 28.3334H15C14.779 28.3334 14.567 28.2456 14.4107 28.0893C14.2545 27.9331 14.1667 27.7211 14.1667 27.5001V12.5001C14.1667 12.2791 14.2545 12.0671 14.4107 11.9108C14.567 11.7545 14.779 11.6667 15 11.6667ZM20 24.1667C20.221 24.1667 20.433 24.2545 20.5892 24.4108C20.7455 24.5671 20.8333 24.7791 20.8333 25.0001C20.8333 25.2211 20.7455 25.4331 20.5892 25.5893C20.433 25.7456 20.221 25.8334 20 25.8334C19.779 25.8334 19.567 25.7456 19.4107 25.5893C19.2545 25.4331 19.1667 25.2211 19.1667 25.0001C19.1667 24.7791 19.2545 24.5671 19.4107 24.4108C19.567 24.2545 19.779 24.1667 20 24.1667Z",
    fill: "#727281"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_Icon.8163e1da2fbbfd6b2a08353750dfaaaa.svg";
export { ForwardRef as ReactComponent };